module.exports = __webpack_public_path__ + "img/back.5799bf94.svg";